import React from "react";
import DefaultButton from "./Button"
import BackButton from "./BackButton"
import LinkButton from "./LinkButton"
import ButtonsHolder from './ButtonsHolder'

const Button = (props) => {
  
  const getVariant = (variant) => {

    switch (variant) {

      default:
      case 'default': return <DefaultButton { ...props } />

      case 'global-back': 
      case 'back': 
        return <BackButton { ...props } />

      case 'link':
        return <LinkButton { ...props } />

    }

  }

  return getVariant(props.variant)

};

export { ButtonsHolder }
export default Button
